<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex>Update Review</v-flex> 
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>    
                </v-card-title>
                <v-card-text>
                    <v-flex wrap>                
                        <v-flex >
                           <span style="font-size: 14px;font-weight: 600;"> Course Title : </span> 
                           <span style="font-size: 18px;font-weight: bold;"> {{ Course_Review.Course_Title }} </span>
                        </v-flex>
                    </v-flex>
                    <v-flex style="padding-top: 12px;">
                        <v-text-field v-model="Review_Message" label="Review Message"></v-text-field>
                    </v-flex>
                    <v-flex style="padding-top: 12px;">
                        <star-rating v-model="Review_Number"></star-rating>
                    </v-flex>
                    <v-flex>
                        <v-checkbox v-model="Review_Status" :label="`Review Status  : ${Review_Status ? 'Approve' : 'Decline'}`"></v-checkbox>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn @click="UpdateReview" style="float:right;">Update Review</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Course_Review            : {},
            Review_Id                : "",
            Review_Message           : "",
            Review_Number            : 1,
            Review_Status            : false
        }
    },
    methods:{
        CloseDialog(){

            this.Course_Review      = {}
            this.Review_Id               = "",
            this.Review_Message          = "",
            this.Review_Number           = 1,
            this.Review_Status           = false
            this.$emit('close')
        },
        SetReviewDetails(Review){
            this.Course_Review = Review
            this.Review_Id       = Review['_id']
            this.Review_Message  = Review['Review_Message']
            this.Review_Number   = Review['Review_Number'] 
            this.Review_Status   = Review['Review_Status']
        },
        UpdateReview(){


            let Review = {}
            Review['Review_Id'] = this.Review_Id 
            Review['Update']   = {}
            Review['Update']['Review_Message'] = this.Review_Message 
            Review['Update']['Review_Number']  = this.Review_Number  
            Review['Update']['Review_Status']  = this.Review_Status 
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursereview/approvecoursereview`,Review)
                        .then(response =>{
                                
                            this.$store.commit("UpdateIndividualReview", response["data"]["response"][0]);    
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        }
    }
}
</script>
<style scoped>
 #editor{
     height: 350px;
 }
  .clsForTicketAdmin{
    margin: 10px 8px;
    padding: 18px 12px;
    text-align: right;
    background: #31356c;
    color: white;
    word-wrap: break-word;
 }
  .clsForTicketUser{
    margin: 10px 8px;
    padding: 18px 12px;
    text-align: left;
    color: black;
    word-wrap: break-word;
    border: 1px solid lightgray;
 }
</style>